import React, { useState } from 'react'
import classes from "./style.module.scss";
import { displayFileType } from '../../../../helpers';

const ResourceDisplay = (props) => {
    const { resourseInfo } = props

    return (
        <>
            <div className={`${classes.resourceCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-3'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Images/Videos
                        </div>
                    </div>
                    <div className={`${classes.displayProductWrapper}`}>
                        <div className={classes.productLogoWrap}>
                            {displayFileType(resourseInfo?.media_file)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResourceDisplay